import metas from "@/modules/Metas/pages/Index";

export default [
  {
    name: "metas",
    path: "/metas",
    component: metas,
    meta: { title: "Metas" },
  },
];
